<script setup>
import StudentInfoItem from '../../../../../../../components/StudentInfoItem.vue';

defineProps({
    details: {
        type: Object,
        required: true,
    },
});

const colors = {
    red: { text: 'text-red-500', background: 'bg-red-500' },
    green: { text: 'text-green-500', background: 'bg-green-500' },
    indigo: { text: 'text-indigo-500', background: 'bg-indigo-500' },
    blue: { text: 'text-blue-500', background: 'bg-blue-500' },
    purple: { text: 'text-purple-500', background: 'bg-purple-500' },
    pink: { text: 'text-pink-500', background: 'bg-pink-500' },
};
</script>

<template>
    <div>
        <div class="mt-5">
            <div class="bg-gray-100 overflow-hidden rounded-lg mt-3">
                <div class="px-4 py-5 sm:p-6">
                    <div class="flex flex-col mt-5">
                        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                            <div
                                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                            >
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead>
                                        <tr class="text-white">
                                            <th
                                                class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"
                                            >
                                                {{ $tc('messages.teams', 1) }}
                                            </th>
                                            <th
                                                class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"
                                            >
                                                {{ $t('messages.percent_of_target') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <template v-for="team in details.teams" :key="team.id">
                                        <thead>
                                            <tr>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-300 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                                                >
                                                    <div class="flex items-center gap-4">
                                                        <div
                                                            :class="colors[team.color].background"
                                                            class="w-8 h-8"
                                                        ></div>
                                                        <span>{{ team.name }}</span>
                                                    </div>
                                                </th>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-300 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                                                >
                                                    <span>{{ team.percent }}%</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="group" v-for="student in team.students" :key="student.id">
                                                <td
                                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex gap-2"
                                                >
                                                    <StudentInfoItem :student="student" />
                                                </td>

                                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                    <span
                                                        :title="student.qty"
                                                        :class="{
                                                            'text-gray-300': student.qty === 0,
                                                        }"
                                                        >{{ student.percent }}%</span
                                                    >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
